/**
* Created by bieao on 2020/5/23.
*/
<template>
    <div class="item-position" id="qunCrane"></div>
</template>

<script>
// 蓝色是Z，绿色是Y  红色是X
import Box from '../common/Box'
export default {
  name: 'ThreeDBox',
  data () {
    return {
      width: 1920,
      height: 1080,
      planeXY: 0,
      renderer: null,
      scene: null,
      camera: null,
      controls: null,
      stats: null,
      cranesArr: [],
      timeRequest: 2, // 2秒请求一次
      cranesStep: {}, // 每一个执行的步长
      oldRunData: {},
      canvasScale: 0, // canvas和实际的比例换算
      craneHeightObj: {},
      boxObj: {} // 塔机的实例
    }
  },
  props: {
    config: {
      type: Number
    },
    boxes: {
      type: Array
    },
    runData: {
      type: Array
    },
    screenChange: {
      type: Number
    }
  },
  watch: {
    config (val, oldVal) {
      if (val !== oldVal) {
        this.planeXY = val + 200
        this.draw()
      }
    },
    boxes (val, oldVal) {
      if (val !== oldVal) {
        this.initAllBox()
      }
    },
    runData (val, oldVal) {
      if (val !== oldVal) {
        this.updateBox()
      }
    },
    screenChange (val, oldVal) {
      if (val !== oldVal) {
        this.camera.aspect = window.innerWidth / window.innerHeight
        this.camera.updateProjectionMatrix()
      }
    }
  },
  methods: {
    /* 初始化渲染器 */
    initRender () {
      this.renderer = new THREE.WebGLRenderer({antialias: true, alpha: true})
      this.renderer.setPixelRatio(window.devicePixelRatio) // 设置为浏览器的像素比
      this.renderer.setSize(this.width, this.height) // 设置窗口大小
      document.getElementById('qunCrane').appendChild(this.renderer.domElement)
    },
    /* 初始化场景 */
    initScene () {
      this.scene = new THREE.Scene()
      this.scene.position.y = -300
    },
    initStats () {
      this.stats = new Stats()
      document.body.appendChild(this.stats.dom)
    },
    /* 初始化摄像头 */
    initCamera () {
      const view_angle = 45, // 垂直方向上的视野夹角
        aspect = window.innerWidth / window.innerHeight, // 可视区域宽高比
        near = 0.1, // 近距
        far = 100000 // 远距离
      this.camera = new THREE.PerspectiveCamera(view_angle, aspect, near, far) // 透视相机
      this.camera.position.set(0.65 * this.planeXY, 1200, 0.64 * this.planeXY) // 相机的位置
      this.camera.lookAt(new THREE.Vector3(0, -500, 0)) // 机头的朝向
    },
    /* 初始化光源 */
    initLight () {
      const position = 0.74 * this.planeXY
      this.scene.add(new THREE.AmbientLight(0xfffffff)) // THREE.AmbientLight属于全局光
      const pointLight = new THREE.PointLight(0xcccccc, 0.9, 0) // 添加点光源
      pointLight.position.set(0, 200, position)
      this.scene.add(pointLight)
      const pointLight1 = new THREE.PointLight(0xcccccc, 0.9, 0) // 添加点光源
      pointLight1.position.set(0, 200, -position)
      this.scene.add(pointLight1)
      const pointLight2 = new THREE.PointLight(0xcccccc, 0.9, 0) // 添加点光源
      pointLight2.position.set(position, 200, 0)
      this.scene.add(pointLight2)
      const pointLight3 = new THREE.PointLight(0xcccccc, 0.9, 0) // 添加点光源
      pointLight3.position.set(-position, 200, 0)
      this.scene.add(pointLight3)
    },
    /* 添加辅助坐标 */
    initCoordinate () {
      const helper = new THREE.AxesHelper(50)
      this.scene.add(helper)
    },
    /* 添加地面 */
    addPlane () {
      let loader = new THREE.TextureLoader()
      let texture = loader.load('/static/img/bg.png')
      let material = new THREE.MeshBasicMaterial({map: texture, side: THREE.DoubleSide})
      let planeGeometry = new THREE.PlaneGeometry(this.planeXY, this.planeXY)
      let plane = new THREE.Mesh(planeGeometry, material)
      plane.rotation.x = -0.5 * Math.PI
      plane.position.y = -5
      plane.name = 'plane'
      this.scene.add(plane)
    },
    /* 重新渲染 */
    render () {
      this.renderer.render(this.scene, this.camera)
    },
    // 循环初始化配电箱
    initAllBox () {
      const len = this.boxes.length
      this.initBox(0, len)
    },
    initBox (index, len) {
      const currentBox = this.boxes[index]
      const box = new Box()
      box.initBox(currentBox, this.scene, () => {
        this.boxObj[currentBox.hashId] = box
        index++
        if (index < len) {
          this.initBox(index, len)
        } else {
          this.$emit('initFinish')
        }
      })
    },
    updateBox () {
      this.runData.forEach((res) => {
        const box = this.boxObj[res.hashId]
        box.update(res)
      })
    },
    addClickEvent () {
      let raycaster = new THREE.Raycaster()
      let mouse = new THREE.Vector2()
      const self = this
      window.addEventListener('click', (event) => {
        let name = ''
        mouse.x = (event.clientX / this.width) * 2 - 1
        mouse.y = -(event.clientY / this.height) * 2 + 1
        raycaster.setFromCamera(mouse, self.camera)
        let intersects = raycaster.intersectObjects(self.scene.children, true)
        for (let i = 0; i < intersects.length; i++) {
          if (intersects[ i ].object.name !== 'plane') {
            if (name !== intersects[ i ].object.name) {
              name = intersects[ i ].object.name
            }
          }
        }
        if (name) {
          this.$emit('clickBox', name)
        }
      }, false)
    },
    calcCameraPosition () {
      if (this.camera) {
        let angle = 0
        const {x, z} = this.camera.position
        if (x > 0) {
          // 右下角
          if (z > 0) {
            angle = Math.atan(x / z)
          } else if (z === 0) {
            angle = Math.PI * 0.25
          } else {
            angle = Math.PI - Math.atan(x / Math.abs(z))
          }
        } else if (x < 0) {
          if (z > 0) {
            angle = 2 * Math.PI - Math.atan(Math.abs(x) / z)
          } else if (z === 0) {
            angle = 1.5 * Math.PI
          } else {
            angle = Math.PI + Math.atan(Math.abs(x) / Math.abs(z))
          }
        }
        for (let key in this.boxObj) {
          const box = this.boxObj[key]
          box.infoPlaneGroup.rotation.y = angle
          box.boxNameMesh.rotation.y = angle
        }
      }
    },
    /* 初始控件 */
    initControls () {
      this.controls = new THREE.OrbitControls(this.camera, this.renderer.domElement)
      // 如果使用animate方法时，将此函数删除
      // controls.addEventListener( 'change', render );
      // 使动画循环使用时阻尼或自转 意思是否有惯性
      this.controls.enableDamping = true
      // 动态阻尼系数 就是鼠标拖拽旋转灵敏度
      // controls.dampingFactor = 0.25;
      // 是否可以缩放
      this.controls.enableZoom = true
      // 是否自动旋转
      this.controls.autoRotate = false
      this.controls.autoRotateSpeed = 0.2
      // 设置相机距离原点的最远距离
      this.controls.minDistance = 1
      // 设置相机距离原点的最远距离
      this.controls.maxDistance = 15000
      // 是否开启右键拖拽
      this.controls.enablePan = true
      // this.controls.maxPolarAngle = 0.5 * Math.PI
    },
    /* 添加动画 */
    animate () {
      this.render()
      this.calcCameraPosition()
      // this.stats.update()
      requestAnimationFrame(this.animate)
    },
    /* 画图 */
    draw () {
      this.initRender()
      this.initScene()
      // this.initStats()
      this.initCamera()
      this.initLight()
      this.addPlane()
      // this.initCoordinate()
      this.initControls()
      this.animate()
      this.addClickEvent()
    }
  },
  mounted () {
  }
}
</script>

<style scoped lang="scss">
  #qunCrane{
    left:0;
    top:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ThreeDBox.vue